import React, { useState } from 'react';
import { Form, Input, Button, Modal, Typography, Row, Col } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Frmcentrocosto = () => {
  const [nombre, setNombre] = useState('');
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const API_URL = `${process.env.REACT_APP_API_URL}/CentroCosto`;

  const handleGuardar = async () => {
    try {
      await form.validateFields();

      const data = {
        nombre: nombre,
        estado: 1
      };

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        setModalMessage('El centro de costos se guardó exitosamente.');
        setIsModalVisible(true);
        setNombre('');
        form.resetFields();
      } else {
        setModalMessage('Error al guardar el centro de costos.');
        setIsModalVisible(true);
      }
    } catch (error) {
      if (error.errorFields) {
        setModalMessage('No se puede dejar vacio el nombre del centro de costos.');
        setIsModalVisible(true);
      }
    }
  };

  return (
    <div style={{ padding: 24, display: 'flex', justifyContent: 'center' }}>
      <div style={{ maxWidth: 600, width: '100%' }}>
        <Title level={3}>Centro de costos</Title>
        <Form form={form} layout="horizontal">
          <Row align="middle" gutter={16}>
            <Col>
              <label style={{ fontWeight: 'bold' }}>
                Nombre <span style={{ color: 'red' }}>*</span>
              </label>
            </Col>
            <Col flex="auto">
              <Form.Item
                name="nombre"
                rules={[{ required: true, message: 'Por favor ingrese el nombre del centro de costos.' }]}
                style={{ marginBottom: 0 }}
              >
                <Input
                  id="txtnombre"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  placeholder="Ingrese nombre"
                />
              </Form.Item>
            </Col>
            <Col>
              <Button
                id="BtnGuardar"
                type="primary"
                icon={<SaveOutlined />}
                onClick={handleGuardar}
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>

        <Modal
          title="Mensaje"
          visible={isModalVisible}
          onOk={() => setIsModalVisible(false)}
          onCancel={() => setIsModalVisible(false)}
          okText="Aceptar"
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <p>{modalMessage}</p>
        </Modal>
      </div>
    </div>
  );
};

export default Frmcentrocosto;
